import { render, staticRenderFns } from "./PopupCardExchange.vue?vue&type=template&id=60201c0a&scoped=true&"
import script from "./PopupCardExchange.vue?vue&type=script&lang=js&"
export * from "./PopupCardExchange.vue?vue&type=script&lang=js&"
import style0 from "./PopupCardExchange.vue?vue&type=style&index=0&id=60201c0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60201c0a",
  null
  
)

export default component.exports